import { PopupTemplate } from "templates/PopupTemplate";
import { Skeleton } from "../../Skeleton";
import * as S from "./styles";

function OccurrencePopupSkeleton() {
  return (
    <PopupTemplate
      renderButtons={
        <div>
          <Skeleton width="100%" height="1.6rem" />
          <Skeleton width="100%" height="1.6rem" />
          <Skeleton width="100%" height="1.6rem" />
        </div>
      }
      isLoading
    >
      <S.WorkingStatus>
        <S.Info>
          <Skeleton width="2rem" height="2rem" />

          <S.Description>
            <Skeleton width="10rem" />
          </S.Description>
        </S.Info>
        <S.Button>
          <Skeleton width="30px" height="30px" />
        </S.Button>
      </S.WorkingStatus>

      <S.Badge className={"skeleton"}>
        <Skeleton height="2rem" />
      </S.Badge>
    </PopupTemplate>
  );
}

export { OccurrencePopupSkeleton };
